
import Link from 'next/link'
import Router from 'next/router'


import ButtonGenStyles from '../../styles/elements/ButtonGenStyles.module.scss'

const handleClick = (e) => {
    e.preventDefault()
    router.push(href)
  }

const Button = ({buttonName, link}) => {
    return (
      <Link href={link}>
        <div className={ButtonGenStyles.button}>{buttonName}</div>
      </Link>
    );
}

export default Button
